import { mutationOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type { TaskDto } from '../task/model';
import type { LongVideoTranslateVideoInputDto } from './model';

export const longVideoTranslateVideo = mutationOptions({
  mutationFn: async (input: LongVideoTranslateVideoInputDto) => {
    const data = await http
      .post('video/long-video/translate', {
        json: input,
      })
      .json<TaskDto[]>();
    return data;
  },
});
